"use client";
import {JSX} from "react";

import {useTranslation} from "@/shared/i18n";
import {ButtonBase} from "@/shared/ui/buttons/button-base";

import type {DestinationListRenderProps} from "../destination-list";

interface ViewAllButtonProps extends DestinationListRenderProps {
    viewAllLink?: string;
}

export function ViewAllButton({viewAllLink, ...props}: ViewAllButtonProps): JSX.Element {
    const {t} = useTranslation("common");

    // If viewAllLink is provided, use it as external link, otherwise use inline expansion
    if (viewAllLink) {
        return (
            <div className="destination__header-actions">
                <ButtonBase as="link" href={viewAllLink} variant="secondary-outline" size="sm" width="auto" className="destination__button-view-all">
                    {t("viewAll")}
                </ButtonBase>
            </div>
        );
    }

    return (
        <div className="destination__header-actions">
            <ButtonBase
                variant="secondary-outline"
                size="sm"
                onClick={() => props.actions?.showAll()}
                width="auto"
                className="destination__button-view-all"
            >
                {t("viewAll")}
            </ButtonBase>
        </div>
    );
}
